import { createUseStyles } from 'react-jss';
import { ITheme } from '../../components/theme';

type RuleNames =
  | 'contentHeaderText'
  | 'mainContent'
  | 'createBtn'
  | 'tabsBlock';

const PREFIX = 'Main';
export const useStyles = createUseStyles<RuleNames, unknown, ITheme>(
  (theme: ITheme) => (
    {
      contentHeaderText: {
        fontWeight: 500,
        fontSize: '20px',
        color: theme.darkGreen,
        fontFamily: theme.caslonDoric,
      },
      mainContent: {
        width: '1160px',
        margin: '32px auto',
      },
      createBtn: {
        fontFamily: theme.helveticaNeueMedium,
        backgroundColor: theme.lightGreen,
        color: theme.darkGreen,
        fontSize: '14px',
        padding: '6px 16px',
        '&:hover': {
          backgroundColor: theme.hoverLightGreen,
        },
      },
      tabsBlock: {
        height: '36px',
        margin: '32px 0 24px',
        display: 'flex',
        justifyContent: 'space-between',
      },
    }
  ),
  { name: PREFIX },
);
